import React from 'react';
import { API, Auth } from 'aws-amplify';
import DataTable from 'react-data-table-component';

class ListUsers extends React.Component {
    constructor(props) {
        super(props);

        this.state  ={
            users: []
        };
    }

    columns = [
        {
          name: 'Email',
          selector: 'email',
          sortable: true,
        },
        {
          name: 'Client',
          selector: 'client',
          sortable: true
        },
        {
          name: 'Report Access',
          selector: 'report_access',
          sortable: true
        },
        {
          name: 'Email Status',
          selector: 'status',
          sortable: true,
          maxWidth: '200px'
        },
        {
          name: 'Enabled',
          selector: 'enabled',
          sortable: true,
          maxWidth: '150px'
        },
    ];

    getUsers = async () => {
        const accessToken = (await Auth.currentSession()).accessToken.jwtToken;

        const apiName = 'lookersso';
        const path = '/users';
        const myInit = {
            queryStringParameters: {
                accessToken: accessToken
            }
        };

        return await API.get(apiName, path, myInit);
    }

    componentDidMount(){
        this.getUsers().then(data => {
            this.setState({
                users: data
            });
        });
    }

    render() {
        return (
            <DataTable
                title="Users"
                columns={this.columns}
                data={this.state.users}
                pagination={true}
                persistTableHead={true}
                striped={true}
                overflowY={true}
                paginationPerPage={50}
                paginationRowsPerPageOptions={[2,5,10,25,50]}
            />
        );
    }
}

export default ListUsers;

